export default function Sidebar({activeView, onViewChange}) {


    const menuItems = [
        { id: "upload", label: "Upload Video", icon: "bi-cloud-upload" },
        { id: "list", label: "Manage Videos", icon: "bi-list-task" },
        { id: "analytics", label: "Analytics", icon: "bi-bar-chart" },
        // { id: "settings", label: "Settings", icon: "bi-gear" },
      ];

  return (
    <div className="d-flex flex-column h-100">
      <div className="p-3 border-bottom border-secondary">
        <h5 className="text-white-50 mb-0">Admin Portal</h5>
      </div>
      <nav className="nav flex-column mt-2">
        {menuItems.map((item) => (
          <a
            key={item.id}
            className={`nav-link py-3 px-4 d-flex align-items-center ${
                activeView === item.id ? "active bg-black text-white" : "text-white-50"
            }`}
            onClick={(e) => {
                e.preventDefault()
                onViewChange(item.id)
              }}
            style={{ color: "white",cursor: "pointer" }}
          >
            <i className={`me-3 ${item.icon}`} style={{ fontSize: "18px" }}></i>
            {item.label}
          </a>
        ))}
      </nav>

      <div className="mt-auto p-4 border-top border-secondary">
        <div className="d-flex align-items-center">
   
          <div>
            <div className="text-white-50 small">Need help?</div>
            <a className="text-white text-decoration-none" style={{ cursor: "pointer" }}>
                Contact support
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

